import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setGoogleToken } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      console.log('🔍 AuthCallback: Starting authentication process');
      console.log('📍 Current URL:', window.location.href);
      console.log('🔑 Search params:', Object.fromEntries(searchParams));

      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        console.error('❌ OAuth error:', error);
        alert(`Błąd logowania: ${error}`);
        navigate('/login');
        return;
      }

      if (!token) {
        console.error('❌ No token found in URL');
        alert('Brak tokenu autoryzacji');
        navigate('/login');
        return;
      }

      try {
        console.log('🔐 Token received:', token.substring(0, 20) + '...');
        
        // Dekoduj token JWT aby sprawdzić jego zawartość
        const tokenParts = token.split('.');
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));
          console.log('📋 Token payload:', payload);
          console.log('⏰ Token expires at:', new Date(payload.exp * 1000).toLocaleString());
        }

        // Zaloguj użytkownika używając Google token
        const result = await setGoogleToken(token);
        
        if (result.success) {
          console.log('✅ Login successful, redirecting to dashboard');
        } else {
          console.error('❌ Login failed:', result.message);
          throw new Error(result.message || 'Login failed');
        }
        
        // Przekieruj na dashboard
        navigate('/dashboard');
      } catch (error) {
        console.error('❌ Login error:', error);
        alert('Błąd podczas logowania. Spróbuj ponownie.');
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams, navigate, setGoogleToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto"></div>
        <p className="mt-4 text-white">Logowanie...</p>
        <p className="text-sm text-gray-400 mt-2">Jeśli widzisz ten ekran dłużej niż 5 sekund, sprawdź konsolę przeglądarki</p>
      </div>
    </div>
  );
};

